import { NotFoundPage } from '@pages/not-found-page/not-found-page'
import { createRootRoute } from '@tanstack/react-router'
import { LayoutPage } from './layout-page'
import { LayoutPageError } from './layout-page.error'

export const baseRoute = createRootRoute({
  component: LayoutPage,
  notFoundComponent: NotFoundPage,
  errorComponent: LayoutPageError
})
